import React from 'react'

import { useOnClickOutside } from '@web/walter-ui-kit'
import { useSearchSlotContext } from '~contexts/SearchContext'

export const useStopSearching = () => {
    const { isSearching, stopSearching } = useSearchSlotContext()

    const searchResultsRef = React.useRef<HTMLDivElement>(null)
    const searchRef = React.useRef<HTMLDivElement>(null)

    useOnClickOutside(
        () => {
            if (isSearching) {
                stopSearching()
            }
        },
        { refs: [searchResultsRef, searchRef], trigger: 'click' }
    )

    return { searchResultsRef, searchRef }
}
